import { SegmentKeyList } from '@zurich/api/contract';
// FIXME: this format is outdated and will be replaced by the format in the utils/ folder
// please do not create new namespaces but rather use the utils functions to create helpers easier
// TODO: deprecate with SegmentKeyUtils - add translations there
export var ContractSegmentKey;
(function (ContractSegmentKey) {
    ContractSegmentKey.getTranslatedValue = (value) => value.toString().split('_')?.pop() ?? null;
    ContractSegmentKey.getInitialValue = (value) => {
        // NOTE: not needed anymore as we are not using gql anymore!
        const splitSegment = value.toString().split('_');
        return `${splitSegment[1]}.${splitSegment[2]}_${splitSegment[3]}`;
    };
    function createInitialOptions() {
        return ContractSegmentKey.getAllValues().map((segmentKey) => ({
            label: ContractSegmentKey.getTranslatedValue(segmentKey) || 'not translated',
            value: ContractSegmentKey.getInitialValue(segmentKey),
        }));
    }
    ContractSegmentKey.createInitialOptions = createInitialOptions;
    function createInitialLongOptions(t) {
        return ContractSegmentKey.getAllValues().map((segmentKey) => ({
            label: t(`contract:insuranceSegment.${String(ContractSegmentKey.getTranslatedValue(segmentKey))}`),
            value: segmentKey,
        }));
    }
    ContractSegmentKey.createInitialLongOptions = createInitialLongOptions;
    function getAllValues() {
        return SegmentKeyList;
    }
    ContractSegmentKey.getAllValues = getAllValues;
    function createOptions() {
        return ContractSegmentKey.getAllValues().map((segmentKey) => ({
            label: ContractSegmentKey.getTranslatedValue(segmentKey) || 'not translated',
            value: segmentKey,
        }));
    }
    ContractSegmentKey.createOptions = createOptions;
})(ContractSegmentKey || (ContractSegmentKey = {}));
